(function() {
  var mpDelimiter = "|";
  var sectionId = document.querySelector('#sectionIdContainer').attributes['data-section_id'].value 
  var productJSONSelector = `ProductJson-${sectionId}`;
  var mpBundleJSONSelector = 'ProductJson-product-mp-bundle-options';
  var mpVariantsJSONSelector = 'ProductJson-product-mp-bundle-variants';
  var productObject = JSON.parse(document.getElementById(productJSONSelector).innerHTML);
  var mpBundleObject = JSON.parse(document.getElementById(mpBundleJSONSelector).innerHTML);
  var mpVariantsObject = JSON.parse(document.getElementById(mpVariantsJSONSelector).innerHTML);

  var addToCartButton = document.querySelector(`#ProductSubmitButton-${sectionId}` );
  var addToCartButtonTextContainer = document.querySelector(`#ProductSubmitButtonText-${sectionId}` );
  var addToCartButtonText = addToCartButtonTextContainer.innerText;


  var mpBundleOptions = [];
  for (var i in mpBundleObject) {
    for (var j in mpBundleObject[i].options) {
      mpBundleOptions.push(mpBundleObject[i].options[j]);
    }
  }

  for (var x in productObject.variants) {
    var variant_id = productObject.variants[x].id;
    var mpKey = mpVariantsObject.variants[variant_id].split(mpDelimiter);
    for (y=0; y < mpBundleOptions.length; y++) {
      var z = y+1;
      productObject.variants[x]['option'+z] = mpKey[y];
    }
  }

  document.getElementById(productJSONSelector).innerHTML = JSON.stringify(productObject);

  // Attach change event listeners to our MP Bundle form options
  var elements = document.getElementsByClassName("mp-bundle-option");

  var myFunction = function() {
      var inputs = document.getElementsByClassName("mp-bundle-option");
      var vals = [];

      for (var i = 0; i < inputs.length; i++) {
          if (inputs[i].checked) {
              vals.push(inputs[i].value);
          }
      }

      var bundleKey = vals.join(mpDelimiter);

      //console.log("Looking for: " + bundleKey);

      var variantIds = Object.keys(mpVariantsObject.variants);
      var foundId = 0;
      for (variantId in mpVariantsObject.variants) {
          if (mpVariantsObject.variants[variantId] == bundleKey) {
              //console.log("Found: " + variantId + " : " + mpVariantsObject.variants[variantId]);
              foundId = variantId;
              break;
          }
      }

      var foundPos = variantIds.indexOf(foundId);
      var variant = productObject.variants.find(item => item.id === parseInt(foundId)); 

      var price = variant.price;
      document.querySelectorAll('.price.price--large .price-item').forEach(item => {
        item.innerHTML = `$${price / 100}`;
      });

      // enable / disable add to cart button
      if(variant.available) {
        addToCartButton.classList.remove('disabled');
        addToCartButton.removeAttribute('disabled')
        addToCartButtonTextContainer.innerText = addToCartButtonText;
      } else {
        addToCartButton.classList.add('disabled');
        addToCartButton.setAttribute('disabled', 'disabled')
        addToCartButtonTextContainer.innerText = 'Sold out';
      }
      
      var x = document.querySelectorAll("div.product-form__variants option");

      if (x[foundPos.disabled]) {
          //console.log("option is disabled");
      } else {
        x.forEach( item => {
          item.removeAttribute('selected');
        })
        x[foundPos].setAttribute('selected', 'selected');
        document.querySelector('.product-form__option-name .product-form__selected-value').innerText = x[foundPos].innerText;
        
        document.querySelectorAll(`input[name="id"]`).forEach(item => {
          item.value = foundId;
        })
      }
  };

  for (var i = 0; i < elements.length; i++) {
      elements[i].addEventListener('change', myFunction, false);
  }

  window.addEventListener('load', ev => {
    myFunction()
  })
})()